import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

import { Router } from "@angular/router";
import { HomeDataService } from "src/app/services/home-data.service";

@Component({
    selector: "app-onboarding-popup",
    templateUrl: "./onboarding-popup.component.html",
    styleUrls: ["./onboarding-popup.component.scss"],
    standalone: true,
})
export class OnboardingPopupComponent {
  constructor(
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: string,
    private matDailogRef: MatDialogRef<OnboardingPopupComponent>,
    private homeDataService: HomeDataService,
  ) {
    setTimeout(() => {
      this.show = true;
    }, 1000);
  }
  url: any;
  show = false;


  closeOnbording() {
    this.homeDataService.hideOnboardingPopup(this.data);
    this.matDailogRef.close();
  }
}
